import { prewarmModule } from "@/lib/rtk-query-prewarm"
import React from "react"
import {
  buildCreateApi,
  coreModule,
  fetchBaseQuery,
  reactHooksModule,
  ApiProvider as RTKQApiProvider,
} from "@reduxjs/toolkit/query/react"
import {
  createDispatchHook,
  createSelectorHook,
  createStoreHook,
  ReactReduxContextValue,
} from "react-redux"

const ApiReduxContext = React.createContext<ReactReduxContextValue | null>(null)

const hooks = {
  useDispatch: createDispatchHook(ApiReduxContext),
  useSelector: createSelectorHook(ApiReduxContext),
  useStore: createStoreHook(ApiReduxContext),
}

const createApi = buildCreateApi(
  coreModule(),
  reactHooksModule({ hooks }),
  prewarmModule({ hooks }),
)

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({ baseUrl: "/" }),
  endpoints: (builder) => ({
    getSpecialities: builder.query<SelectOption<number>[], number>({
      query: (listingProfileId) =>
        `educators/api/v1/specialities?listing_profile_id=${listingProfileId}`,
      transformResponse: (response: { specialities: SelectOption<number>[] }) =>
        response.specialities,
    }),
  }),
})

export const ApiProvider = ({ children }: React.PropsWithChildren) =>
  React.createElement(
    RTKQApiProvider,
    { api, context: ApiReduxContext } satisfies Omit<
      React.ComponentProps<typeof RTKQApiProvider>,
      "children"
    > as unknown as React.ComponentProps<typeof RTKQApiProvider>,
    children,
  )

export const { useGetSpecialitiesQuery, useGetSpecialitiesPrewarm } = api
